<template>
    <el-dialog
        class="add-cabinet-dialog"
        :visible.sync="visible"
        :title="$t('Common.zidong')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="90px"
            label-suffix=":">
            <el-form-item prop="storeId" :label="$t('Common.store')">
                <el-select
                    class="pr-2 reception-store"
                    v-model="form.storeId"
                    @change="fetchArea"
                    :placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index.id"
                        :label="item.name"
                        :value="Number(item.id)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="storeAreaId" :label="$t('Reception.Fourth.area1')">
                <el-select
                    class="pr-2 reception-store"
                    v-model="form.storeAreaId"
                    placeholder="$t('Reception.Fourth.choose_area_place')">
                    <el-option
                            v-for="(item, index) in areas"
                            :key="index.id"
                            :label="item.name"
                            :value="Number(item.id)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="initial" :label="$t('Reception.Fourth.shou')">
                <el-input
                    type="text"
                    v-model="form.initial"
                    :placeholder="$t('Reception.Fourth.shou_placeholder')">
                </el-input>
            </el-form-item>
            <el-form-item prop="lockerNum" :label="$t('Reception.Fourth.start')">
                <el-input
                    v-model="form.lockerNum"
                    :placeholder="$t('Reception.Fourth.start_placeholder')">
                </el-input>
            </el-form-item>
            <el-form-item prop="createNum" :label="$t('Reception.Fourth.count')">
                <el-input
                    type="number"
                    v-model.number="form.createNum"
                    :placeholder="$t('Reception.Fourth.count_placeholder')">
                </el-input>
            </el-form-item>
            <el-form-item prop="increaseNum" :label="$t('Reception.Fourth.di')">
                <el-input
                    type="number"
                    v-model.number="form.increaseNum"
                    :placeholder="$t('Reception.Fourth.di_placeholder')">
                </el-input>
            </el-form-item>
            <!-- 租赁柜数据 -->
            <div v-if="Number(status) == 2">
                <el-form-item prop="price" :label="$t('Reception.Fifth.price')">
                    <el-input
                        type="number"
                        v-model.number="form.price"
                        :placeholder="$t('Reception.Fifth.price_placeholder')">
                    </el-input>
                </el-form-item>
                <el-form-item
                    :label="$t('Reception.Fifth.transfer')" prop="transferFee">
                    <el-select
                        class="caninet-methods-select"
                        v-model="form.transferType"
                        :placeholder="$t('Common.please_choose')">
                        <el-option
                            :label="$t('Reception.Fifth.bai')"
                            value="1">
                        </el-option>
                        <el-option
                            :label="$t('Reception.Fifth.amt')"
                            value="2">
                        </el-option>
                    </el-select>
                    <el-input
                        class="caninet-num-input"
                        type="number"
                        v-model.number="form.transferFee"
                        :placeholder="form.transferType == 2 ? $t('Reception.Fifth.amt_placeholder') : $t('Reception.Fifth.bai_placeholder')">
                    </el-input>
                    &nbsp; {{ form.transferType == 2 ? $t('Reception.Fifth.yuan') : '%' }}
                </el-form-item>
            </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('Common.cancel') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Message.confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    name: 'add-cabinet',
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                storeId: null,
                areaName: '',
                storeAreaId: null,
                lockerNum: null,
                createNum: null,
                increaseNum: null,
                initial: '',
                // status 为 2
                price: null,
                transferType: null,
                transferFee: true,
            },
            rules: {
                storeId: { type: 'number', required: true, message: this.$t('Common.store_placeholder') },
                storeAreaId: { type: 'number', required: true, message: this.$t('Reception.Fourth.choose_area_place')},
                initial: { type: 'string', required: true, message: this.$t('Reception.Fourth.shou_placeholder') },
                lockerNum: { type: 'string', required: true, message: this.$t('Reception.Fourth.start_placeholder') },
                createNum: { type: 'number', required: true, message: this.$t('Reception.Fourth.count_placeholder') },
                increaseNum: { type: 'number', required: true, message: this.$t('Reception.Fourth.di_placeholder') },
                areaName: { type: 'string', required: true, message: this.$t('Reception.Fourth.area_name_placeholder') },
                price: { type: 'number', required: true, message: this.$t('Reception.Fifth.price_placeholder') },
            },
            stores: [],
            areas: [],
            status: null, // 为1时是临时储物柜，为2时是租赁柜。
            storeId: '',
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(status,storeId) {
            this.form = {
                storeId: storeId,
            };
            this.status = status; // 为1时是临时储物柜，为2时是租赁柜。
            this.fetchStore();
            this.visible = true;
        },
        fetchStore() {
            // 门店
            API.get('store/list').then(res => {
                this.stores = res;
            });
            if (this.form.storeId) this.fetchArea();
        },
        fetchArea() {
            API.get('area', {
                params: {
                    storeId: this.form.storeId
                },
            }).then(res => {
                this.areas = res;
                if (res && res.length) this.$set(this.form, 'storeAreaId', res[0].id);
                else this.$set(this.form, 'storeAreaId', null);
            });
        },
        confirm() {
            if (Number(this.status) === 2) {
                const transferFee = {
                    transferFee: {
                        type: 'number',
                        required: true,
                        message: this.$t('Reception.Fifth.transfer_placeholder'),
                    },
                };
                this.rules = Object.assign({}, this.rules, transferFee);
            }
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            const url = Number(this.status) === 1 ? 'temporary-locker' : 'locker';
            delete form.storeId;
            delete form.areaName;
            if (Number(this.status) === 1) {
                delete form.price;
                delete form.transferFee;
                delete form.isFixed;
            }
            API.post(url, form).then(res => {
                $ele.$message.success(this.$t('Message.success'));
                this.$emit('fetchLocker', 1);
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.add-cabinet-dialog {
    .el-dialog {
        width: 430px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .caninet-methods-select {
        width: 100px;
        margin-right: 4px;
    }
    .caninet-num-input {
        width: 140px;
    }
}
</style>
